import KendoComboBoxMixin from './KendoComboBoxMixin'

export default {
    name: 'kendo-combobox',
    mixins: [ KendoComboBoxMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoComboBox/index.js